


















import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { formatPrice } from '@/util/format'

@Component
export default class TotalPrice extends Vue {
  @Prop({ required: true })
  totalPrice: number

  @Prop({ default: false })
  isLoading: boolean

  get formatPrice() {
    return formatPrice
  }
}
